
import React, { useState } from 'react'
import { Box, Typography, useMediaQuery } from '@mui/material'
import IconReusable from '../../components/IconReusable'
import { CustomButton } from '../../v2/MUI_custom_component'
import GlassModal from '../../v2/MUI_custom_component/Modal/GlassModal';
import Privacy from '../CompanyPolicies/Privacy';
import RefundPolicy from '../CompanyPolicies/RefundPolicy';
import CancellationPolicy from '../CompanyPolicies/CancellationPolicy';
import TermConditions from '../CompanyPolicies/TermConditions';

const policyData = [
  {
        key: 'privacy',
        label: 'Privacy Policy',
        iconName: 'Privacy'
  },
  {
        key: 'refund',
        label: 'Refund Policy',
        iconName: 'RefundMoney',
  },
  {
        key: 'cancellation',
        label: 'Cancellation Policy',
        iconName: 'CancelPolicy',
  },
  {
        key: 'tnc',
        label: 'Terms and Conditions',
        iconName: 'Tnc',
  },
];

const PolicyCard = ({ iconName, iconColor, title, buttonLabel, onButtonClick, isMobile }) => (
    <Box sx={{
        display: 'flex',
        backgroundColor: '#fff',
        padding: '16px',
        borderRadius: 2,
        alignItems: 'center',
        gap: 2,
        width: '100%',
        justifyContent: 'space-between',
    }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Box sx={{
                width: 32,
                height: 32,
                borderRadius: 1,
                backgroundColor: '#F7F7F7',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}>
                <IconReusable name={iconName} size={24} color={iconColor} />
            </Box>
            <Typography variant='h2'>{title}</Typography>
        </Box>
        <CustomButton
            variant='text'
            size={isMobile ? 'small' : 'medium'}
            label={buttonLabel}
            onClick={onButtonClick}
        />
    </Box>
);

const Policies = () => {
    const isMobile = useMediaQuery('(max-width: 1200px)');
    const [openPolicyModal, setOpenPolicyModal] = useState(false);
    const [selectedPolicy, setSelectedPolicy] = useState(null);

    const handlePolicyClick = (policy) => {
        setSelectedPolicy(policy);
        setOpenPolicyModal(true);
    };

    const handleClosePolicyModal = () => {
        setOpenPolicyModal(false);
        setSelectedPolicy(null);
    };

    const renderSelectedPolicy = () => {
        if (!selectedPolicy) return null;

        switch (selectedPolicy.key) {
            case 'privacy':
                return <Privacy inModal={true} />;
            case 'refund':
                return <RefundPolicy inModal={true} />;
            case 'cancellation':
                return <CancellationPolicy inModal={true} />;
            case 'tnc':
                return <TermConditions inModal={true} />;
            default:
                return null;
        }
    };

    return (
        <Box
            sx={{
                p: 2,
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
            }}
        >
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Typography variant='h2'>
                    Policies
                </Typography>
                <Typography variant='body1'>
                    You can view our policies below. For more details or specific queries, feel free to reach out. Our team will connect with you at the earliest.
                </Typography>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                {policyData.map((policy, index) => (
                    <PolicyCard
                        key={index}
                        iconName={policy.iconName}
                        iconColor='#995A00'
                        title={policy.label}
                        buttonLabel='View Policy'
                        isMobile={isMobile}
                        onButtonClick={() => handlePolicyClick(policy)}
                    />
                ))}
            </Box>

            <GlassModal
                open={openPolicyModal}
                onClose={handleClosePolicyModal}
                title={selectedPolicy?.label || 'Policy'}
                scrollable={true}
                maxWidth='600px'
                padding = {false}
                zIndex={2}
            >
                {renderSelectedPolicy()}
            </GlassModal>
        </Box>
    )
}

export default Policies